module.exports = __webpack_public_path__ + "static/media/yotube-search-history.0efb010a.svg";